import { initLiveList } from '../../shared/liveList.js';

// The reachable-customers search on the candidate's Karte section (D15): its
// filter row, wired to refetch the results region rather than reload the page.
//
// Its own module rather than part of kandidatKarte.js, because the two have
// different preconditions - the same split kundeUmkreis.js makes next door. The
// table renders whenever the candidate has a point and a means of transport; the
// map additionally needs MAPBOX_PUBLIC_TOKEN. Folding them together would mean
// the list stopped filtering on an installation with no browser token, turning a
// configuration problem into a data one.
//
// The markers are not this module's business: kandidatKarte.js watches the same
// region and redraws them from the payload the server sends with each fragment,
// so there is nothing to coordinate here.
export function initKandidatErreichbar() {
  // The list's own URL is this page's, which already carries the candidate id.
  // Read off the location rather than a data attribute: replaceState keeps it
  // correct as filters change, and the redirect guard inside liveList compares
  // pathnames.
  initLiveList({
    results: 'erreichbare-kunden',
    path: window.location.pathname,
    forms: ['erreichbar-filter']
  });
}
